import { Suspense } from "react";
import { DynamicHeader } from "./DynamicHeader";
import { Footer } from "./Footer";
import { Outlet } from "react-router-dom";
import { AppLoadingScreen } from "@/components/shared/AppLoadingScreen";

export const AdminLayout = () => {
    return (
        <div className="min-h-screen-safe flex flex-col page-bg selection:bg-blue-100">
            <DynamicHeader />
            <main className="flex-1 w-full overflow-x-hidden pt-[calc(6rem+env(safe-area-inset-top))] pb-[max(5.5rem,env(safe-area-inset-bottom))] md:pb-14">
                <Suspense fallback={<AppLoadingScreen message="Loading admin page..." />}>
                    <Outlet />
                </Suspense>
            </main>
            <Footer />
        </div>
    );
};
